export default __webpack_public_path__ + "static/media/loading-indicator.c6b8d2a1.svg";